/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetOwnerForMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetOwnerForMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetOwnerForMerchant = (request: BatchGetOwnerForMerchantRequest, options?: CashRequestOptions) => post<BatchGetOwnerForMerchantRequest, BatchGetOwnerForMerchantResponse>("/2.0/cash/batch-get-owner-for-merchant", request, {...options, rejectOnError: true })